import { Inject, Injectable } from '@angular/core';
import {catchError, lastValueFrom, of, take } from 'rxjs';
import { ScimMappingConfig, ScimMappingConfigUpdate, Environment, ENVIRONMENT } from '@netfoundry-ui/shared/model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import _ from 'lodash';
import { HateoasResourceOperation } from '@lagoshny/ngx-hateoas-client';
import { HTTP_CLIENT } from '@netfoundry-ui/shared/services';

@Injectable({
    providedIn: 'root',
})
export class ScimMappingConfigService extends HateoasResourceOperation<ScimMappingConfig> {
  
    apiUrl;

    constructor(
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(ScimMappingConfig);
        this.apiUrl = environment.integrationsManagementUrl + "scim-mapping-configs";
    }

    getMappingConfigForIntegration(integrationId: string): Promise<ScimMappingConfig | undefined> {
        return this.http.get(this.apiUrl, {  headers: { accept: 'application/hal+json' }, params: { scimIntegrationId: integrationId.toString() }})
            .toPromise()
            .then((result: any) => {
                if(result?.page?.totalElements === 1) {
                    const mappingConfigs: any = (result?._embedded?.scimMappingConfigs as ScimMappingConfig[]) || [];
                    return mappingConfigs[0];
                } else {
                    throw new Error('Unable to find Mapping Config for this Integration. Please contact support for additional help');
                }
            });
    }

    async save(model: ScimMappingConfig): Promise<any[]> {
        const results = await this.validate(model);
        if (!_.isArray(results) || results.length === 0) {
            if (!model.id) {
                this.createResource({ body: model })
                    .pipe(take(1))
                    .subscribe({
                        next: () => [],
                        error: (err) => [{ save: err.status }],
                    });
            } else {
                const mappingConfigUpdateModel = new ScimMappingConfigUpdate(model.name, model.mappings);
                this.patchResourceById(model.id, {body: mappingConfigUpdateModel})
                    .pipe(take(1))
                    .subscribe({
                        next: () => [],
                        error: (err) => [{ save: err.status }],
                    });
            }
        }
        return results;
    }

    validate(model: ScimMappingConfig): any {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        if (model?.id) {
            const mappingConfigUpdateModel = new ScimMappingConfigUpdate(model.name, model.mappings);
            return lastValueFrom(
                this.http
                    .patch(this.apiUrl + '/' + model.id, mappingConfigUpdateModel, {
                        headers: headers,
                        responseType: 'json',
                    })
                    .pipe(catchError((err) => of([{ http: err }])))
            );
        } else if (model) {
            return lastValueFrom(
                this.http
                    .post(this.apiUrl , model, {
                        headers: headers,
                        responseType: 'json',
                    })
                    .pipe(catchError((err) => of([{ http: err }])))
            );
        } else return Promise.resolve([{ invalid: 'ScimMappingConfig model cannot be undefined' }]);
    }

    
}
